module.exports = __webpack_public_path__ + "img/icon-bgjzd.5a028629.png";